@if (noActivatedChildren$ | async) {
    <div class="container-fluid pb-3">
        @if (view$ | async; as view) {
            <div class="w-100 d-flex justify-content-end mt-0">
                <div class="btn-group d-flex my-3">
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="createVariableAlarm()">
                        {{ 'monitoring_create-variable-alarm' | translate }}
                    </button>
                    <button
                        type="button"
                        class="btn mx-1 btn-outline-primary"
                        (click)="setViewMode('card')">
                        <i
                            class="bi bi-border-all"
                            style="vertical-align: middle; display: inline-flex"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="setViewMode('table')">
                        <i
                            class="bi bi-list-ul"
                            style="vertical-align: middle; display: inline-flex"></i>
                    </button>
                </div>
            </div>
            @if (viewMode === 'table') {
                <app-variable-alarms-table
                    [variableAlarms]="view.variableAlarms"
                    (deleteVariableAlarm)="deleteVariableAlarm(view.buildingNo, $event)"
                    (editAlarm)="editVariableAlarm($event)"
                    (duplicateAlarm)="
                        duplicateVariableAlarm(view.buildingNo, $event)
                    "></app-variable-alarms-table>
            } @else {
                <app-variable-alarms-card-view
                    [variableAlarms]="view.variableAlarms"
                    (deleteVariableAlarm)="deleteVariableAlarm(view.buildingNo, $event)"
                    (editAlarm)="editVariableAlarm($event)"
                    (duplicateAlarm)="
                        duplicateVariableAlarm(view.buildingNo, $event)
                    "></app-variable-alarms-card-view>
            }
        } @else {
            <app-load></app-load>
        }
    </div>
}
<router-outlet />
